import { Typography, Card, Tag, Empty, Space } from 'antd';
import { t } from '../../i18n/i18n';
import './NodeOutputPanel.scss';

const { Title, Text } = Typography;

const NodeOutputPanel = ({ currentNode }) => {
  if (!currentNode || !currentNode.template?.outputs) {
    return (
      <div className="node-output-panel">
        <Card className="output-panel-card">
          <Empty description={t('ALKYMATION_NO_OUTPUTS')} image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </Card>
      </div>
    );
  }

  return (
    <div className="node-output-panel">
      <Card className="output-panel-card">
        <div className="panel-header">
          <div className="d-flex align-items-center mb-3">
            <img
              className="node-icon-small"
              src={`data:image/svg+xml;base64,${btoa(currentNode.template?.icon)}`}
              style={{
                backgroundColor: currentNode.template?.color || '#666',
                padding: '4px 8px',
                borderRadius: '4px',
                color: 'white',
                marginRight: '8px',
              }}
              alt=""
            />
            <div>
              <Title level={5} className="mb-0">
                {t('ALKYMATION_OUTPUT_DATA')}
              </Title>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                {t(currentNode.name)}
              </Text>
            </div>
          </div>
        </div>

        <div className="panel-content">
          <Text type="secondary" className="d-block mb-3">
            {t('ALKYMATION_AVAILABLE_OUTPUTS')}:
          </Text>
          <Space direction="vertical" className="w-100 output-list">
            {currentNode.template.outputs.map((output) => (
              <Card key={output.id} size="small" className="output-item-card">
                <div className="output-item">
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="flex-grow-1">
                      <Text strong className="d-block">
                        {t(output.name)}
                      </Text>
                      {output.description && (
                        <Text type="secondary" className="output-description">
                          {t(output.description)}
                        </Text>
                      )}
                    </div>
                    <Tag color="blue" size="small">
                      {output.type}
                    </Tag>
                  </div>
                  {output.schema && (
                    <div className="mt-2">
                      <Text type="secondary" style={{ fontSize: '11px' }}>
                        {t('ALKYMATION_SCHEMA')}:
                      </Text>
                      <pre className="schema-preview">{JSON.stringify(output.schema, null, 2)}</pre>
                    </div>
                  )}
                </div>
              </Card>
            ))}
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default NodeOutputPanel;
